<template>
  <ModalXD>
    <div class="news-container">
      <div class="input-wrapper">
        <h1 class="title">Legg til nyhet</h1>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Redaktør: </label>
          <input type="text" placeholder="Redaktør" v-model="newsItem.author" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Tittel: </label>
          <input type="text" placeholder="Tittel" v-model="newsItem.title" />
        </div>
      </div>
      <div class="input-wrapper">
        <label>Bilde:</label>
        <input type="file" ref="newsitemfile" class="image-selector" accept="image/*" @change="handleFileUpload" />
      </div>
      <div class="input-wrapper">
        <label>Bilde beskrivelse:</label>
        <input type="text" placeholder="Beskrivelse" v-model="newsItem.description" />
      </div>
      <div class="input-wrapper">
        <div>
          <label> Innhold: </label>

          <Editor api-key="l3hxtpsgpdlf3ypuwfuqta730sunu7tbe9u1kqc4kjgdvxds" :init="{
            toolbar_mode: 'sliding',
            plugins: [
              // Core editing features
              'autolink',
              'lists',
              'searchreplace',
              'table',
              'wordcount',
            ],
            toolbar:
              'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | align lineheight | checklist numlist bullist indent outdent | removeformat',
            tinycomments_mode: 'embedded',
            tinycomments_author: 'Author name',
          }" initial-value="Welcome to TinyMCE!" v-model="newsItem.content" />
        </div>
      </div>
      <div class="input-wrapper">
        <button @click="publishNewsItem">
          Publiser<span class="material-icons">publish</span>
        </button>
      </div>
    </div>
  </ModalXD>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import ModalXD from "@/components/ModalXD.vue";
import { storage } from '@/database/storage'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'

export default {
  name: "ModalNews",
  components: { Editor, ModalXD },

  data() {
    return {
      file: null,
      newsItem: {
        title: "",
        content: "",
        author: "",
        img: null,
        description: "",
        authorTimestamp: null,
        editorTimestamp: null,
      },
    };
  },
  
  methods: {
    handleFileUpload(e) {
      this.file = e.target.files[0];
    },

    async publishNewsItem() {
      try {
        const payload = { ...this.newsItem };

        if (this.file) {
          const fileRef = storageRef(storage, `newsItems/${this.file.name}`);
          await uploadBytes(fileRef, this.file);
          const url = await getDownloadURL(fileRef);
          payload.img = url;
        }
          payload.authorTimestamp = Date.now();
        // Pass docId if editing an existing item
        if (this.newsItem.docId) {
          payload.docId = this.newsItem.docId;
          await this.$store.dispatch("updateNewsItem", payload);
        } else {
          await this.$store.dispatch("addNewsItem", payload);
        }

        this.$emit("close");
        this.$toast.success("Nyhet lagret");
      } catch (err) {
        console.error(err);
        this.$toast.error("Kunne ikke lagre nyheten");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.news-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;

  .input-wrapper {
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    width: 100%;

    * {
      width: 100%;
      margin: 5px;
      margin-right: 15px;
      padding: 0;
    }

    button {
      margin: 0px;
      padding: 20px;
      font-size: 1em;
      background: #2a8355;
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      span {
        margin: 0 5px;
        width: fit-content;
      }
    }
  }
}

p {
  margin: 0;
  padding: 0;
  font-size: 1em;
}

.txt-ara {
  height: 10em;
  white-space: pre-wrap;
}

.custom-file-upload {
  padding: 20px;
  font-size: 1em;
  background: #2a8355;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
